export const orgPurchaseLimit = {
  header: 'Toutes les limites d\'achat ({{count}})',
  name: 'Nom',
  code: 'Code',
  active: 'Statut',
  limit: 'Limite',
  orderApprovalPermissionType: 'Type',
  threshold: 'Seuil',
  periodRange: 'Période',
  currency: 'Devise',
  orgUnit: 'Unité parente',
  unit: 'Unité parente',
  actions: '',
  hint: 'Les limites d\'achat aident à contrôler les dépenses en définissant le montant que les acheteurs peuvent dépenser par commande ou par semaine, mois, trimestre ou année. Les limites d\'achat sont assignées aux utilisateurs ou aux groupes d\'utilisateurs. Elles sont également assignées aux approbateurs pour définir le montant qu\'ils sont autorisés à approuver.',
  details: {
    title: 'Détails de la limite d\'achat',
    subtitle: 'Limite d\'achat : {{ item.code }}',
  },
  edit: {
    title: 'Modifier la limite d\'achat',
    subtitle: 'Limites d\'achat : {{ item.code }}',
  },
  create: {
    title: 'Créer une limite d\'achat',
    subtitle: '',
  },
  sortBy: 'Trier par',
  sort: {
    byName: 'Nom',
    byUnitName: 'Unité',
  },
  messages: {
    deactivateTitle: 'Désactiver cette limite d\'achat?',
    deactivate: 'Les limites d\'achat désactivées ne peuvent plus être assignées à un utilisateur ou un groupe d\'utilisateurs. Les assignations actuelles n\'auront aucun effet.',
    confirmEnabled: 'Limite d\'achat {{ item.code }} activée avec succès',
    confirmDisabled: 'Limite d\'achat {{ item.code }} désactivée avec succès',
    update: 'Limite d\'achat {{ item.code }} mise à jour avec succès',
    create: 'Limite d\'achat {{ item.code }} créée avec succès',
  },
  info: {
    disabledEdit: 'Activez la limite d\'achat pour permettre la modification.',
    disabledEnable: 'L\'unité doit être activée avant que cette limite d\'achat puisse être activée.',
  },
  per: {
    DAY: 'par jour',
    WEEK: 'par semaine',
    MONTH: 'par mois',
    QUARTER: 'par trimestre',
    YEAR: 'par année',
  },
  breadcrumbs: {
    list: 'Toutes les limites d\'achat',
    details: '{{code}}',
  },
};
